import { api } from 'roboflex-thalamus-request-handler'

let pendente = null

function baseStorage() {
    const base = process.env.VUE_APP_ROOT_STORAGE || ''
    return base && !base.endsWith('/') ? `${base}/` : base
}

/**
 * Reaproveita a mesma origem do avatar do header: pessoa/usuario + VUE_APP_ROOT_STORAGE.
 * A promise é memoizada porque o drawer é remontado a cada abertura.
 */
export function carregarFotoUsuarioLogado() {
    if (!pendente) {
        pendente = api.get('pessoa/usuario')
            .then((response) => {
                const path = response?.data?.path_image || response?.data?.data?.path_image
                return path ? `${baseStorage()}${path}` : ''
            })
            .catch(() => '')
    }
    return pendente
}
